import React from "react";
import { Box, Typography } from "@mui/material";

const RejectInfoPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        textAlign: "center",
        maxWidth: "600px",
      }}
    >
      <Typography variant="h3" component="h1" gutterBottom>
        Thank You!
      </Typography>
      <Typography
        variant="h5"
        component="p"
        gutterBottom
        sx={{ color: "#d32f2f" }}
      >
        Your contract has been rejected.
      </Typography>

      <Typography variant="body1" paragraph>
        We regret to inform you that your contract has not been accepted. Please
        review the details of your submission.If you need clarification or have
        any questions, don't hesitate to reach out to our hardhats team.
      </Typography>
    </Box>
  );
};

export default RejectInfoPage;
